module.exports = __webpack_public_path__ + "img/charge002.a79ae61f.png";